/**
 * @file step3
 * @author zhaomiaoyuan
 */
import React, {useCallback} from 'react';
import {withRouter} from 'react-router';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';

import successIcon from '../../asset/img/appeal/submit_succeed.png';
import {Button} from 'antd';
import {recordProxy} from '../../util';

const Step3 = (props) => {
    const {
        tip,
        btn1Url,
        btn2Url,
        btn1Text,
        btn2Text,
    } = props;
    const history = useHistory();
    /* eslint-disable */
    const onHome = useCallback(() => {
        const recordType = window.location.pathname.indexOf('/mark_msg') > -1
            ? 'report-modify_url-home' : 'report_url-home';
        recordProxy(recordType, 'click', btn1Text);
        history.push(btn1Url);
    });
    const onRecord = useCallback(() => {
        const recordType = window.location.pathname.indexOf('/mark_msg') > -1
            ? 'report-modify_url-record' : 'report_url-record';
        recordProxy(recordType, 'click', btn2Text);
        history.push(btn2Url);
    });
    /* eslint-enable */

    return (
        <div className="step-3">
            <div className="submit-success">
                <img width={152} src={successIcon} />
                <p className="title">提交成功!</p>
                <p className="sub-title">
                    {tip}
                </p>
                <Button
                    className="btn"
                    onClick={onHome}
                >
                    {btn1Text}
                </Button>
                {btn2Text && <Button
                    className="btn"
                    onClick={
                        onRecord
                    }
                >
                    {btn2Text}
                </Button>}
            </div>
        </div>
    );
};

Step3.propTypes = {
    tip: PropTypes.string,
    btn1Url: PropTypes.string,
    btn2Url: PropTypes.string,
    btn1Text: PropTypes.string,
    btn2Text: PropTypes.string,
};

export default withRouter(Step3);
